import ControlView from "../views/renderer/ControlView";
import {STYLE_INJECTION_MIXIN} from "../mixins/style-injection-mixin";
import { getLocalizedField } from "../utils/languageHelper";

const RENDERER_SECTION_VIEW_MIXIN = {
    components: {
        ControlView // Show Control
    },

    mixins: [STYLE_INJECTION_MIXIN],
    props: {
        section: Object,
        rows: Object,
        controls: Object,
        visibleMap: Object,
        valueContainer: Object,
        validationErrors: Object,
        readOnly: Boolean,
        viewSubmissionMode: Boolean,
        siteID: String,
        patNum: Number,
        logoUrl: String,
        formSubmissionIDForWeb: String,
        language: {
            type: String,
            default: 'en'
        }
    },

    data: () => ({

    }),

    methods: {

    },

    computed: {
        /**
         * Localized section headline
         */
        localizedSectionHeadline() {
            if (!this.section) return '';
            return getLocalizedField(this.section, 'headline', this.language);
        },

        /**
         * Localized section sub-headline
         */
        localizedSectionSubHeadline() {
            if (!this.section) return '';
            return getLocalizedField(this.section, 'subHeadline', this.language);
        },

        filteredControls() {
            const controls = this.controls || {}
            const visibleMap = this.visibleMap || {}
            return (this.section.controls || []).filter(controlId => {
                const control = controls[controlId]
                if (!control) return false
                const key = control.name ? control.name : control.uniqueId
                if (!key) return true
                if (!Object.prototype.hasOwnProperty.call(visibleMap, key)) return true
                return !!visibleMap[key]
            })
        },


        /**
         * Classes for draggable
         * @returns {(string|string)[]}
         */
        containerClasses() {
            return [
                this.styles.ROW,
                'control-list-container'
            ]
        }
    },
};

export {
    RENDERER_SECTION_VIEW_MIXIN
}